var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.496 10.8L11.12 8.176C11.216 8.08 11.3333 8.032 11.472 8.032C11.6107 8.032 11.728 8.08 11.824 8.176C11.92 8.272 11.968 8.38933 11.968 8.528C11.968 8.66667 11.92 8.784 11.824 8.88L8 12.704L4.176 8.88C4.08 8.784 4.032 8.66667 4.032 8.528C4.032 8.38933 4.08 8.272 4.176 8.176C4.272 8.08 4.38933 8.032 4.528 8.032C4.66667 8.032 4.784 8.08 4.88 8.176L7.504 10.784V4.992H1.008V15.008H15.008V4.992H8.496V10.8ZM7.504 4V0H8.496V4H16V15.008C16 15.2747 15.904 15.504 15.712 15.696C15.52 15.8987 15.2853 16 15.008 16H1.008C0.730667 16 0.490667 15.904 0.288 15.712C0.096 15.52 0 15.2853 0 15.008V4H7.504Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorExport);
export default __webpack_public_path__ + "static/media/vector-export.ab745403a8dba11173159ef0f5376d7e.svg";
export { ForwardRef as ReactComponent };